export default __webpack_public_path__ + "static/media/privacyPolicy_root_background.4c4d778f.jpg";